<template>
  <!-- Bootstrap modal overlay -->
  <div v-if="visible" class="modal d-block" tabindex="-1" @click.self="close">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fas fa-info-circle me-2 text-primary"></i>{{ title }}
          </h5>
          <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="mb-0" style="white-space: pre-wrap;">{{ description }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" @click="close">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Backdrop -->
  <div v-if="visible" class="modal-backdrop fade show"></div>
</template>

<script>
/**
 * SettingsHelpModal
 *
 * A reusable pure-display modal that shows a title and description string.
 * Contains no settings-specific logic and may be used anywhere in the admin
 * section for contextual help content.
 *
 * Props:
 *   title       (String) - Modal heading text.
 *   description (String) - Body text shown in the modal.
 *   visible     (Boolean) - Controls whether the modal is shown.
 *
 * Emits:
 *   close - Emitted when the user dismisses the modal.
 */
export default {
  name: 'SettingsHelpModal',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal {
  background: transparent;
}
</style>
